import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: import.meta.env.BASE_URL,
  routes: [
    {
      path: "/@*", // catch any route starting with @ these are special short links
      name: "premium-link",
      component: () =>
        import(/* webpackChunkName: "short-link" */ "./views/ShortLink.vue")
    },
    {
      path: "/~*", // catch any route starting with ~ these are normal short links
      name: "normal-link",
      component: () =>
        import(/* webpackChunkName: "short-link" */ "./views/ShortLink.vue")
    },
    {
      path: "/home",
      name: "home",
      alias: "/biz",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/Home2.vue")
    },
    {
      path: "/splash",
      name: "splash",
      alias: "/",
      component: () =>
        import(/* webpackChunkName: "splash" */ "./views/Splash.vue")
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () =>
        import(
          /* webpackChunkName: "privacy-policy" */ "./views/PrivacyPolicy.vue"
        )
    },
    // {
    //   path: '/',
    //   name: 'home',
    //   component: () => import(/* webpackChunkName: "home" */ './views/Home2.vue')
    // },
    {
      path: "/home_old",
      name: "home-old",
      alias: "/0",
      component: () =>
        import(/* webpackChunkName: "home-2" */ "./views/Home.vue")
    },
    {
      path: "/profile",
      name: "profile",
      alias: "/logout",
      component: () =>
        import(/* webpackChunkName: "profile" */ "./views/Profile.vue")
    },
    {
      path: "/business_profile/:id",
      name: "business_profile",
      component: () =>
        import(
          /* webpackChunkName: "business_profile" */ "./views/BusinessProfile.vue"
        )
    },
    {
      path: "/business_login",
      name: "business_login",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "business_login" */ "./views/BusinessLogin.vue"
        )
    },
    {
      path: "/commerce_home",
      name: "commerce_home",
      component: () =>
        import(
          /* webpackChunkName: "commerce_home" */ "./views/CommerceHome.vue"
        )
    },
    {
      path: "/commerce_home/:id",
      name: "commerce_home_id",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "commerce_home" */ "./views/CommerceHome.vue"
        )
    },
    {
      path: "/commerce_page/:page",
      name: "commerce_page",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "commerce_page" */ "./views/CommercePage.vue"
        )
    },
    {
      path: "/shop_signup",
      name: "shop-signup",
      component: () =>
        import(/* webpackChunkName: "shop_signup" */ "./views/ShopSignup.vue")
    },
    {
      path: "/restaurant_signup",
      name: "restaurant-signup",
      component: () =>
        import(
          /* webpackChunkName: "restaurant_signup" */ "./views/RestaurantSignup.vue"
        )
    },
    {
      path: "/new_shop",
      name: "shop-new",
      component: () =>
        import(/* webpackChunkName: "shop_new" */ "./views/ShopNew.vue")
    },
    {
      path: "/shop_plans",
      name: "shop-plans",
      component: () =>
        import(/* webpackChunkName: "shop_plans" */ "./views/ShopPlans.vue")
    },
    {
      path: "/shop_create",
      name: "shop-create",
      component: () =>
        import(/* webpackChunkName: "shop_create" */ "./views/ShopCreate.vue")
    },
    {
      path: "/super_ops",
      name: "super-ops",
      component: () =>
        import(/* webpackChunkName: "super_ops" */ "./views/SuperOps.vue")
    },
    // {
    //   path: "/tuktuk",
    //   name: "tuktuk",
    //   component: () =>
    //     import(/* webpackChunkName: "tuktuk" */ "./views/Tuktuk.vue"),
    // },
    {
      path: "/tuktuk_dispatcher",
      name: "tuktuk-dispatcher",
      component: () =>
        import(
          /* webpackChunkName: "tuktuk-dispatcher" */ "./views/TuktukDispatcher.vue"
        )
    },
    {
      path: "/fleet_dispatcher",
      name: "fleet-dispatcher",
      component: () =>
        import(
          /* webpackChunkName: "fleet-dispatcher" */ "./views/FleetDispatcher.vue"
        )
    },
    {
      path: "/ride",
      name: "ride",
      component: () => import(/* webpackChunkName: "ride" */ "./views/Ride.vue")
    },
    {
      path: "/ride_booking/:id",
      name: "ride-booking",
      component: () =>
        import(/* webpackChunkName: "ride-booking" */ "./views/RideBooking.vue")
    },
    {
      path: "/driver",
      name: "driver",
      component: () =>
        import(
          /* webpackPrefetch: true */ /* webpackChunkName: "driver" */ "./views/Driver.vue"
        )
    },
    {
      path: "/dispatcher_fleet",
      name: "dispatcher-fleet",
      component: () =>
        import(
          /* webpackChunkName: "dispatcher_fleet" */ "./views/DispatcherFleet.vue"
        )
    },
    {
      path: "/dispatcher_jobs",
      name: "dispatcher-jobs",
      component: () =>
        import(
          /* webpackChunkName: "dispatcher_jobs" */ "./views/DispatcherJobs.vue"
        )
    },
    {
      path: "/shop",
      name: "shop",
      component: () => import(/* webpackChunkName: "shop" */ "./views/Shop.vue")
    },
    {
      path: "/eat",
      name: "eat",
      component: () => import(/* webpackChunkName: "eat" */ "./views/Eat.vue")
    },
    {
      path: "/loading",
      name: "loading",
      alias: "/l",
      component: () =>
        import(/* webpackChunkName: "loading" */ "./views/Loading.vue")
    },
    {
      path: "/deleteme",
      name: "deleteme",
      component: () =>
        import(/* webpackChunkName: "deleteme" */ "./views/DeleteMe.vue")
    },
    {
      path: "/menu_editor",
      name: "menu-editor",
      component: () =>
        import(/* webpackChunkName: "menu-editor" */ "./views/MenuEditor.vue")
    },
    {
      path: "/list_editor",
      name: "list-editor",
      component: () =>
        import(/* webpackChunkName: "list-editor" */ "./views/ListEditor.vue")
    },
    {
      path: "/link_shortener",
      name: "link-shortener",
      component: () =>
        import(
          /* webpackChunkName: "link-shortener" */ "./views/LinkShortener.vue"
        )
    },
    {
      path: "/translator",
      name: "translator",
      component: () =>
        import(/* webpackChunkName: "translator" */ "./views/Translator.vue")
    },
    {
      path: "/shop/:id",
      name: "shop-profile",
      alias: "/express/:id",
      props: true,
      component: () =>
        import(/* webpackChunkName: "shop-profile" */ "./views/ShopProfile.vue")
    },
    {
      path: "/driver_wallet/:id",
      name: "driver-wallet-view",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "driver_wallet_view" */ "./views/DriverWalletView.vue"
        )
    },
    {
      path: "/driver_route/:id",
      name: "driver-route",
      props: true,
      component: () =>
        import(/* webpackChunkName: "driver_route" */ "./views/DriverRoute.vue")
    },
    {
      path: "/past_addresses/:id",
      name: "past-addresses",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "past_addresses" */ "./views/PastAddresses.vue"
        )
    },
    {
      path: "/user_lookup",
      name: "user-lookup",
      component: () =>
        import(/* webpackChunkName: "user-info" */ "./views/UserInfo.vue")
    },
    {
      path: "/user_info/:id",
      name: "user-info",
      props: true,
      component: () =>
        import(/* webpackChunkName: "user-info" */ "./views/UserInfo.vue")
    },
    {
      path: "/orders",
      name: "orders",
      component: () =>
        import(/* webpackChunkName: "orders" */ "./views/Orders.vue")
    },
    {
      path: "/search",
      name: "search",
      component: () =>
        import(/* webpackChunkName: "search" */ "./views/Search.vue")
    },
    {
      path: "/search/:id",
      props: true,
      name: "search-param",
      component: () =>
        import(/* webpackChunkName: "search" */ "./views/Search.vue")
    },
    {
      path: "/issues",
      name: "issues",
      component: () =>
        import(/* webpackChunkName: "issues" */ "./views/Issues.vue")
    },
    {
      path: "/qr/:id",
      name: "qr",
      component: () =>
        import(/* webpackChunkName: "qrlookup" */ "./views/QRLookup.vue")
    },
    {
      path: "/q/:id",
      name: "short-link",
      component: () =>
        import(/* webpackChunkName: "short-link" */ "./views/ShortLink.vue")
    },
    {
      path: "/qrscanner",
      name: "qr-scanner",
      component: () =>
        import(/* webpackChunkName: "qrscanner" */ "./views/QRScanner.vue")
    },
    {
      path: "/control",
      name: "control-centre",
      component: () =>
        import(/* webpackChunkName: "control" */ "./views/ControlCentre.vue")
    },
    {
      path: "/delivery",
      name: "delivery-dispatch",
      component: () =>
        import(
          /* webpackChunkName: "delivery" */ "./views/DeliveryDispatch.vue"
        )
    },
    {
      path: "/batch",
      name: "delivery-batch",
      component: () =>
        import(/* webpackChunkName: "batch" */ "./views/DeliveryBatch.vue")
    },
    {
      path: "/commerce",
      name: "commerce",
      component: () =>
        import(/* webpackChunkName: "commerce" */ "./views/Commerce.vue")
    },
    {
      path: "/ecommerce",
      name: "e-commerce",
      component: () =>
        import(/* webpackChunkName: "e-commerce" */ "./views/Ecommerce.vue")
    },
    {
      path: "/ecommerce/:id",
      name: "e-commerce-id",
      props: true,
      component: () =>
        import(/* webpackChunkName: "e-commerce" */ "./views/Ecommerce.vue")
    },
    {
      path: "/logistics_fleet",
      name: "logistics-fleet",
      component: () =>
        import(
          /* webpackChunkName: "logistics-fleet" */ "./views/LogisticsFleet.vue"
        )
    },
    {
      path: "/logistics_jobs",
      name: "logistics-jobs",
      component: () =>
        import(
          /* webpackChunkName: "logistics-jobs" */ "./views/LogisticsJobs.vue"
        )
    },
    {
      path: "/logistics_order/:id",
      name: "logistics-order",
      component: () =>
        import(
          /* webpackChunkName: "logistics-order" */ "./views/LogisticsOrder.vue"
        )
    },
    {
      path: "/commerce_order/:id",
      name: "commerce-order",
      alias: "/o/:id",
      component: () =>
        import(
          /* webpackChunkName: "commerce-order" */ "./views/CommerceOrder.vue"
        )
    },
    {
      path: "/commerce_agent_order/:id",
      name: "commerce-agent-order",
      props: true,
      alias: "/cao/:id",
      component: () =>
        import(
          /* webpackChunkName: "commerce-agent-order" */ "./views/CommerceAgentOrder.vue"
        )
    },
    {
      path: "/invoice/:id",
      name: "invoice",
      component: () =>
        import(/* webpackChunkName: "invoice" */ "./views/Invoice.vue")
    },
    {
      path: "/user/:id",
      name: "user",
      component: () => import(/* webpackChunkName: "user" */ "./views/User.vue")
    },
    {
      path: "/payment",
      name: "payment",
      component: () =>
        import(/* webpackChunkName: "payment" */ "./views/Payment.vue")
    },
    {
      path: "/geometry",
      name: "geometry",
      component: () =>
        import(/* webpackChunkName: "geometry" */ "./views/Geometry.vue")
    },
    {
      path: "/order_confirmation/:id",
      name: "order-confirmation",
      component: () =>
        import(
          /* webpackChunkName: "order_confirmation" */ "./views/OrderConfirmation.vue"
        )
    },
    {
      path: "/cb",
      name: "circuit-breaker",
      component: () =>
        import(/* webpackChunkName: "cb" */ "./views/CircuitBreaker.vue")
    },
    {
      path: "/cb/:id",
      name: "circuit-breaker-bid",
      meta: { title: "Circuit Breaker Delivery Bidding Tool" },
      component: () =>
        import(/* webpackChunkName: "cb-bid" */ "./views/CircuitBreakerBid.vue")
    },
    // {
    //   path: '/dashboard',
    //   name: 'dashboard',
    //   component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue'),
    // },
    {
      path: "/install",
      redirect: { path: "/qr/install" }
      // name: 'install',
      // component: () => import(/* webpackChunkName: "qrscanner" */ './views/Install.vue'),
    },
    {
      path: "/tuktuk",
      redirect: { path: "/fleet_dispatcher" }
    },
    {
      path: "/siilor",
      redirect: { path: "/tuktuk", query: { type: "siilor" } }
    },
    {
      path: "/privatetuk",
      redirect: { path: "/tuktuk", query: { type: "privatetuk" } }
    },
    {
      path: "/d",
      redirect: { path: "/tuktuk", query: { start_work: true } } // or "true"
    },
    {
      path: "/share", // this was to be used with for android sharing target
      redirect: { path: "/home" } // but it seems you can't do it yet...
    },
    {
      path: "/release_notes",
      name: "release-notes",
      component: () =>
        import(
          /* webpackChunkName: "release-notes" */ "./views/ReleaseNotes.vue"
        )
    },
    {
      path: "/no_such_user",
      name: "no-such-user",
      component: () =>
        import(/* webpackChunkName: "no-such-user" */ "./views/NoSuchUser.vue")
    },
    // {
    //   path: '/q/:id',
    //   redirect: { path: '/qr/:id' } // redirect to qr code lookup
    // }
    // {
    //   path: '/',
    //   redirect: '/home',
    // },
    {
      path: "/lb",
      // redirect: "/home?r=lb",
      redirect: { path: "/home", query: { r: "lb" } }
    },
    {
      path: "/lbmart",
      redirect: { path: "@martlisbon", query: { r: "lb" } }
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
  // scrollBehavior(to, from, savedPosition) {
  //   console.log("scrollBehavior savedPosition", savedPosition)
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
});
